//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 안전작업 관리 - 안전작업 허가서 (SAM_BASIC_02) 전용 로직
 * other 케이스에서 사용
 */

// 이미지를 Base64로 변환하는 함수
const ConvertImageToBase64 = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) return '';
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('이미지 변환 오류:', error);
    return '';
  }
};

// 안전작업 허가서 조회 함수
export const SearchLogic1 = async (apiUrl, procedureParams, dispatch, setLoading) => {
  setLoading(true);

  try {
    const result = await apiRequest(
      'post',
      apiUrl,
      procedureParams
    );

    let data = result.data;

    if (data.length === 0) {
      dispatch(
        showSnackbar({
          message: '조회된 데이터가 없습니다.',
          type: 'info',
        })
      );
      return [];
    } else if (data[0]?.type === 'Error') {
      dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
      return [];
    } else {
      // 날짜 포맷팅 처리
      data.forEach((item) => {
        const date1 = new Date(item.workStartDate);
        const date2 = new Date(item.workEndDate);

        const year = date1.getFullYear();
        const month = String(date1.getMonth() + 1).padStart(2, '0');
        const day = String(date1.getDate()).padStart(2, '0');
        const hours = String(date1.getHours()).padStart(2, '0');
        const minutes = String(date1.getMinutes()).padStart(2, '0');

        const year2 = date2.getFullYear();
        const month2 = String(date2.getMonth() + 1).padStart(2, '0');
        const day2 = String(date2.getDate()).padStart(2, '0');
        const hours2 = String(date2.getHours()).padStart(2, '0');
        const minutes2 = String(date2.getMinutes()).padStart(2, '0');

        item.workStartDate = `${year}-${month}-${day} ${hours}:${minutes}`;
        item.workEndDate = `${year2}-${month2}-${day2} ${hours2}:${minutes2}`;
        item.createDate = item.createDate.substr(0, 10);
      });

      return Commons.InsertNumber(data);
    }
  } catch (e) {
    console.error(e);
    dispatch(showSnackbar({ message: e.message, type: 'error' }));
    return [];
  } finally {
    setLoading(false);
  }
};

// 안전작업 허가서 인쇄 함수
export const PrintLogic1 = async (
  documentData, // 선택된 항목 데이터
  dispatch,
  setLoading
) => {
  if (!documentData) {
    dispatch(
      showSnackbar({
        message: '항목을 선택하세요.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);

  try {
    const selectedItem = Array.isArray(documentData)
      ? documentData[0]
      : documentData;
    const pmCd = selectedItem.pmCd || selectedItem.PmCd || selectedItem.PM_CD;

    const result = await apiRequest(
      'post',
      Global.urls.DocsManagement.getSamBasic02R2,
      { PmCd: Commons.EncryptAES(pmCd) || '' }
    );

    const rows = result?.data;
    const dataRows = Array.isArray(rows) ? rows : rows ? [rows] : [];
    if (!dataRows.length || dataRows[0]?.type === 'Error') {
      dispatch(
        showSnackbar({
          message: '상세 정보를 조회할 수 없습니다.',
          type: 'warning',
        })
      );
      return null;
    }

    const reportData = dataRows[0];

    // 부서장 승인자 ID 배열 파싱 (카멜케이스와 PascalCase 모두 지원 - 관리자 Search2 onSuccess와 동일)
    const depApproverIdString =
      reportData.depApproverId ||
      reportData.DepApproverId ||
      reportData.depApproverIds ||
      '';
    const depApproverIdArray = depApproverIdString
      ? depApproverIdString.split(',').map((id) => id.trim())
      : [];
    const depApproverIdPadded = [];
    for (let i = 0; i < 4; i++) {
      depApproverIdPadded.push(depApproverIdArray[i] || '');
    }

    // 부서장 서명 이미지 Base64 변환 (Commons.EncodeUrl 적용)
    const depSignPath1 =
      reportData.depSignPath1 || reportData.DepSignPath1 || '';
    const depSignPath2 =
      reportData.depSignPath2 || reportData.DepSignPath2 || '';
    const depSignPath3 =
      reportData.depSignPath3 || reportData.DepSignPath3 || '';
    const depSignPath4 =
      reportData.depSignPath4 || reportData.DepSignPath4 || '';

    let depSignBase64 = null;
    let depSignBase64_2 = null;
    let depSignBase64_3 = null;
    let depSignBase64_4 = null;

    if (depSignPath1) {
      const imageUrl1 = Global.file.useUrl + 'files/' + Commons.EncodeUrl(depSignPath1);
      const base64Image1 = await ConvertImageToBase64(imageUrl1);
      depSignBase64 = base64Image1.replace(/^data:image\/[a-z]+;base64,/, '');
    }
    if (depSignPath2) {
      const imageUrl2 = Global.file.useUrl + 'files/' + Commons.EncodeUrl(depSignPath2);
      const base64Image2 = await ConvertImageToBase64(imageUrl2);
      depSignBase64_2 = base64Image2.replace(/^data:image\/[a-z]+;base64,/, '');
    }
    if (depSignPath3) {
      const imageUrl3 = Global.file.useUrl + 'files/' + Commons.EncodeUrl(depSignPath3);
      const base64Image3 = await ConvertImageToBase64(imageUrl3);
      depSignBase64_3 = base64Image3.replace(/^data:image\/[a-z]+;base64,/, '');
    }
    if (depSignPath4) {
      const imageUrl4 = Global.file.useUrl + 'files/' + Commons.EncodeUrl(depSignPath4);
      const base64Image4 = await ConvertImageToBase64(imageUrl4);
      depSignBase64_4 = base64Image4.replace(/^data:image\/[a-z]+;base64,/, '');
    }

    const safetySignPath =
      reportData.safetySignaturePath || reportData.SafetySignaturePath;
    let smSignBase64 = null;
    if (safetySignPath) {
      const safetyImageUrl = Global.file.useUrl + 'files/' + Commons.EncodeUrl(safetySignPath);
      const base64Image = await ConvertImageToBase64(safetyImageUrl);
      smSignBase64 = base64Image.replace(/^data:image\/[a-z]+;base64,/, '');
    }

    const createDate =
      reportData.createDate ||
      reportData.CreateDate ||
      reportData.CREATE_DATE ||
      '';
    const permitDate = createDate
      ? dayjs(createDate).format('YYYY-MM-DD')
      : '';

    const formatDate = (dateValue) => {
      if (!dateValue) return '';
      const formatted = dayjs(dateValue).format('YYYY-MM-DD');
      return formatted === 'Invalid Date' ? '' : formatted;
    };

    // 선택된 위험사항 코드 (카멜/Pascal 지원)
    const selectedRiskCodes =
      reportData.selectedRiskCodes || reportData.SelectedRiskCodes
        ? (reportData.selectedRiskCodes || reportData.SelectedRiskCodes)
          .split(',')
          .map((code) => code.trim())
        : [];

    const riskItems = [];
    const riskItemsList =
      reportData.riskItemsList || reportData.RiskItemsList;
    if (riskItemsList) {
      const riskItemsArray = riskItemsList.split('||');
      riskItemsArray.forEach((item) => {
        const parts = item.split('|');
        if (parts.length >= 2) {
          const code = parts[0];
          const name = parts[1];
          const isChecked = selectedRiskCodes.includes(code);
          riskItems.push({ code, name, checked: isChecked });
        }
      });
    }

    const selectedEquipmentCodes =
      reportData.selectedEquipmentCodes ||
        reportData.SelectedEquipmentCodes
        ? (reportData.selectedEquipmentCodes ||
          reportData.SelectedEquipmentCodes)
          .split(',')
          .map((code) => code.trim())
        : [];

    const equipmentItems = [];
    const equipmentItemsList =
      reportData.equipmentItemsList || reportData.EquipmentItemsList;
    if (equipmentItemsList) {
      const equipmentItemsArray = equipmentItemsList.split('||');
      equipmentItemsArray.forEach((item) => {
        const parts = item.split('|');
        if (parts.length >= 2) {
          const code = parts[0];
          const name = parts[1];
          const isChecked = selectedEquipmentCodes.includes(code);
          equipmentItems.push({ code, name, checked: isChecked });
        }
      });
    }

    const selectedPreparationCodes =
      reportData.selectedPreparationCodes ||
        reportData.SelectedPreparationCodes
        ? (reportData.selectedPreparationCodes ||
          reportData.SelectedPreparationCodes)
          .split(',')
          .map((code) => code.trim())
        : [];

    const preparationItems = [];
    const preparationItemsList =
      reportData.preparationItemsList || reportData.PreparationItemsList;
    if (preparationItemsList) {
      const preparationItemsArray = preparationItemsList.split('||');
      preparationItemsArray.forEach((item) => {
        const parts = item.split('|');
        if (parts.length >= 2) {
          const code = parts[0];
          const name = parts[1];
          const isChecked = selectedPreparationCodes.includes(code);
          preparationItems.push({ code, name, checked: isChecked });
        }
      });
    }

    const workTypeCode =
      reportData.workTypeCode ||
      reportData.workType ||
      reportData.WORK_TYPE_CODE ||
      reportData.WORK_TYPE ||
      '';
    const TableDataMain = [
      {
        WT_001: workTypeCode === 'WT_001',
        WT_002: workTypeCode === 'WT_002',
        WT_003: workTypeCode === 'WT_003',
        WT_004: workTypeCode === 'WT_004',
        WT_005: workTypeCode === 'WT_005',
        WT_006: workTypeCode === 'WT_006',
      },
    ];

    // 위험사항 테이블 데이터 생성 (가로 나열 형태)
    const riskRowData = {};
    riskItems.forEach((item, index) => {
      const fieldIndex = index + 1;
      riskRowData[`RISK_${fieldIndex}_CHECKED`] = item.checked;
      riskRowData[`RISK_${fieldIndex}_NAME`] = item.name;
      riskRowData[`RISK_${fieldIndex}_CODE`] = item.code;
    });
    const riskTableDataHorizontal = [riskRowData];

    // 안전보호구 테이블 데이터 생성 (가로 나열 형태)
    const equipmentRowData = {};
    equipmentItems.forEach((item, index) => {
      const fieldIndex = index + 1;
      equipmentRowData[`EQUIP_${fieldIndex}_CHECKED`] = item.checked;
      equipmentRowData[`EQUIP_${fieldIndex}_NAME`] = item.name;
      equipmentRowData[`EQUIP_${fieldIndex}_CODE`] = item.code;
    });
    const equipmentTableDataHorizontal = [equipmentRowData];

    const validPreparationItems = preparationItems.filter(
      (item) => item && item.code && item.name
    );

    let validWorkerNames = [];
    const workList =
      reportData.workList ||
      reportData.workMemberNo ||
      reportData.WORK_LIST ||
      reportData.WORK_MEMBER_NO;
    if (workList) {
      validWorkerNames = workList
        .split(',')
        .map((name) => name.trim())
        .filter((name) => name);
    }

    const maxRowCount = Math.max(
      validPreparationItems.length,
      validWorkerNames.length
    );

    const preparationTableData = [];
    for (let i = 0; i < maxRowCount; i++) {
      const prepItem =
        i < validPreparationItems.length ? validPreparationItems[i] : null;
      const workerName = i < validWorkerNames.length ? validWorkerNames[i] : '';

      preparationTableData.push({
        PREP_CODE: prepItem?.code || '',
        PREP_NAME: prepItem?.name || '',
        PREP_CHECKED: prepItem?.checked || false,
        WORKER_NAME: workerName,
      });
    }

    // 헤더 데이터 구성 (관리자 Search2 onSuccess와 동일 - 카멜/Pascal 대소문자 지원)
    const headerData = {
      PERMIT_DATE: permitDate,
      PERMIT_NUMBER:
        reportData.pmCd || reportData.PmCd || reportData.PM_CD || '',
      PERMISSION_DATE: permitDate,
      PERMISSION_NO:
        reportData.pmCd || reportData.PmCd || reportData.PM_CD || '',
      SITE_NAME:
        reportData.siteName || reportData.SiteName || reportData.SITE_NAME || '',
      MANAGER_ID:
        reportData.managerId || reportData.ManagerId || reportData.MANAGER_ID || '',
      MANAGER_NAME:
        reportData.managerName || reportData.ManagerName || reportData.MANAGER_NAME || '',
      MANAGER_DEP_CD:
        reportData.managerDepCd || reportData.ManagerDepCd || reportData.MANAGER_DEP_CD || '',
      MANAGER_DEP_NM:
        reportData.managerDepNm || reportData.ManagerDepNm || reportData.MANAGER_DEP_NM || '',
      MANAGER_POSITION:
        reportData.managerPosition || reportData.ManagerPosition || reportData.MANAGER_POSITION || '',
      MANAGER_PHONE:
        reportData.managerPhone || reportData.ManagerPhone || reportData.MANAGER_PHONE || '',
      ETC_CONTENT:
        reportData.etcContent || reportData.EtcContent || reportData.ETC_CONTENT || '',

      COMPANY_NAME:
        reportData.companyName || reportData.CompanyName || reportData.COMPANY_NAME || '',
      DEP_NM:
        reportData.depNm || reportData.DepNm || reportData.DEP_NM || '',

      USER_POSITION:
        reportData.userPosition || reportData.UserPosition || reportData.USER_POSITION || '',
      USER_NAME:
        reportData.userName || reportData.UserName || reportData.USER_NAME || '',
      USER_DEP_NM:
        reportData.userDepNm || reportData.UserDepNm || reportData.USER_DEP_NM || '',

      WORK_START_DATE:
        reportData.workStartDate || reportData.WorkStartDate || reportData.WORK_START_DATE
          ? dayjs(
            reportData.workStartDate ||
            reportData.WorkStartDate ||
            reportData.WORK_START_DATE
          ).format('YYYY-MM-DD HH:mm')
          : '',
      WORK_END_DATE:
        reportData.workEndDate || reportData.WorkEndDate || reportData.WORK_END_DATE
          ? dayjs(
            reportData.workEndDate ||
            reportData.WorkEndDate ||
            reportData.WORK_END_DATE
          ).format('YYYY-MM-DD HH:mm')
          : '',
      PLANNED_PERSONNEL:
        reportData.planNum ||
        reportData.PlanNum ||
        reportData.PLAN_NUM ||
        reportData.plannedPersonnel ||
        reportData.PLANNED_PERSONNEL ||
        '',
      PLAN_NUM:
        reportData.planNum ||
        reportData.PlanNum ||
        reportData.PLAN_NUM ||
        reportData.plannedPersonnel ||
        reportData.PLANNED_PERSONNEL ||
        '',
      NUMBER_OF_WORKERS:
        reportData.numberOfWorkers ||
        reportData.NumberOfWorkers ||
        reportData.NUMBER_OF_WORKERS ||
        '',
      WORK_LOCATION:
        reportData.workLocation || reportData.WorkLocation || reportData.WORK_LOCATION || '',
      WORK_DESCRIPTION:
        reportData.workDescription || reportData.WorkDescription || reportData.WORK_DESCRIPTION || '',
      WORK_LIST:
        reportData.workList ||
        reportData.WorkList ||
        reportData.WORK_LIST ||
        reportData.workDescription ||
        reportData.WorkDescription ||
        reportData.WORK_DESCRIPTION ||
        '',

      WORK_TYPE_NAME:
        reportData.workTypeName || reportData.WorkTypeName || reportData.WORK_TYPE_NAME || '',

      SELECTED_RISK_NAMES:
        reportData.selectedRiskNames ||
        reportData.SelectedRiskNames ||
        reportData.SELECTED_RISK_NAMES ||
        '',
      PREVENTIVE_MEASURES:
        reportData.preventiveMeasures ||
        reportData.PreventiveMeasures ||
        reportData.PREVENTIVE_MEASURES ||
        '',

      GUARDIAN:
        reportData.guardian || reportData.Guardian || reportData.GUARDIAN || '',

      SELECTED_EQUIPMENT_NAMES:
        reportData.selectedEquipmentNames ||
        reportData.SelectedEquipmentNames ||
        reportData.SELECTED_EQUIPMENT_NAMES ||
        '',
      SELECTED_PREPARATION_NAMES:
        reportData.selectedPreparationNames ||
        reportData.SelectedPreparationNames ||
        reportData.SELECTED_PREPARATION_NAMES ||
        '',
      OTHER_SPECIAL_NOTES:
        reportData.etcContent ||
        reportData.EtcContent ||
        reportData.ETC_CONTENT ||
        reportData.OTHER_SPECIAL_NOTES ||
        '',

      DEP_APPROVAL_STATUS_1:
        reportData.depApprovalStatus ||
        reportData.DepApprovalStatus ||
        reportData.DEP_APPROVAL_STATUS ||
        '',
      DEP_APPROVER_ID_1: depApproverIdPadded[0] || '',
      DEP_APPROVER_NM_1:
        reportData.depApproverNm1 ||
        reportData.DepApproverNm1 ||
        reportData.DEP_APPROVER_NM_1 ||
        '',
      DEP_APPROVER_POSITION_1:
        reportData.depApproverPosition1 ||
        reportData.DepApproverPosition1 ||
        reportData.DEP_APPROVER_POSITION_1 ||
        '',
      DEP_APPROVER_DEP_NM_1:
        reportData.depApproverDepNm1 ||
        reportData.DepApproverDepNm1 ||
        reportData.DEP_APPROVER_DEP_NM_1 ||
        '',
      DEP_SIGN_PATH_1: depSignBase64 || null,
      DEP_APPROVER_UPDATE_DATE_1: formatDate(
        reportData.depApproverUpdateDate1 ||
        reportData.DepApproverUpdateDate1 ||
        reportData.DEP_APPROVER_UPDATE_DATE_1 ||
        ''
      ),

      DEP_APPROVER_ID_2: depApproverIdPadded[1] || '',
      DEP_APPROVER_NM_2:
        reportData.depApproverNm2 ||
        reportData.DepApproverNm2 ||
        reportData.DEP_APPROVER_NM_2 ||
        '',
      DEP_APPROVER_POSITION_2:
        reportData.depApproverPosition2 ||
        reportData.DepApproverPosition2 ||
        reportData.DEP_APPROVER_POSITION_2 ||
        '',
      DEP_APPROVER_DEP_NM_2:
        reportData.depApproverDepNm2 ||
        reportData.DepApproverDepNm2 ||
        reportData.DEP_APPROVER_DEP_NM_2 ||
        '',
      DEP_SIGN_PATH_2: depSignBase64_2 || null,
      DEP_APPROVER_UPDATE_DATE_2: formatDate(
        reportData.depApproverUpdateDate2 ||
        reportData.DepApproverUpdateDate2 ||
        reportData.DEP_APPROVER_UPDATE_DATE_2 ||
        ''
      ),

      DEP_APPROVER_ID_3: depApproverIdPadded[2] || '',
      DEP_APPROVER_NM_3:
        reportData.depApproverNm3 ||
        reportData.DepApproverNm3 ||
        reportData.DEP_APPROVER_NM_3 ||
        '',
      DEP_APPROVER_POSITION_3:
        reportData.depApproverPosition3 ||
        reportData.DepApproverPosition3 ||
        reportData.DEP_APPROVER_POSITION_3 ||
        '',
      DEP_APPROVER_DEP_NM_3:
        reportData.depApproverDepNm3 ||
        reportData.DepApproverDepNm3 ||
        reportData.DEP_APPROVER_DEP_NM_3 ||
        '',
      DEP_SIGN_PATH_3: depSignBase64_3 || null,
      DEP_APPROVER_UPDATE_DATE_3: formatDate(
        reportData.depApproverUpdateDate3 ||
        reportData.DepApproverUpdateDate3 ||
        reportData.DEP_APPROVER_UPDATE_DATE_3 ||
        ''
      ),

      DEP_APPROVER_ID_4: depApproverIdPadded[3] || '',
      DEP_APPROVER_NM_4:
        reportData.depApproverNm4 ||
        reportData.DepApproverNm4 ||
        reportData.DEP_APPROVER_NM_4 ||
        '',
      DEP_APPROVER_POSITION_4:
        reportData.depApproverPosition4 ||
        reportData.DepApproverPosition4 ||
        reportData.DEP_APPROVER_POSITION_4 ||
        '',
      DEP_APPROVER_DEP_NM_4:
        reportData.depApproverDepNm4 ||
        reportData.DepApproverDepNm4 ||
        reportData.DEP_APPROVER_DEP_NM_4 ||
        '',
      DEP_SIGN_PATH_4: depSignBase64_4 || null,
      DEP_APPROVER_UPDATE_DATE_4: formatDate(
        reportData.depApproverUpdateDate4 ||
        reportData.DepApproverUpdateDate4 ||
        reportData.DEP_APPROVER_UPDATE_DATE_4 ||
        ''
      ),

      SAFETY_APPROVAL_STATUS:
        reportData.safetyApprovalStatus ||
        reportData.SafetyApprovalStatus ||
        reportData.SAFETY_APPROVAL_STATUS ||
        '',
      SAFETY_APPROVER_ID:
        reportData.safetyApproverId ||
        reportData.SafetyApproverId ||
        reportData.SAFETY_APPROVER_ID ||
        '',
      SAFETY_APPROVER_NM:
        reportData.safetyApproverNm ||
        reportData.SafetyApproverNm ||
        reportData.SAFETY_APPROVER_NM ||
        '',
      SAFETY_APPROVER_POSITION:
        reportData.safetyApproverPosition ||
        reportData.SafetyApproverPosition ||
        reportData.SAFETY_APPROVER_POSITION ||
        '',
      SAFETY_APPROVER_DEP_NM:
        reportData.safetyApproverDepNm ||
        reportData.SafetyApproverDepNm ||
        reportData.SAFETY_APPROVER_DEP_NM ||
        '',
      SAFETY_SIGNATURE_PATH: smSignBase64,
      SAFETY_APPROVER_UPDATE_DATE: formatDate(
        reportData.safetyApproverUpdateDate ||
        reportData.SafetyApproverUpdateDate ||
        reportData.SAFETY_APPROVER_UPDATE_DATE ||
        ''
      ),

      RETURN_STATUS:
        reportData.returnStatus ||
        reportData.ReturnStatus ||
        reportData.RETURN_STATUS ||
        '',
      RETURN_REASON:
        reportData.returnReason ||
        reportData.ReturnReason ||
        reportData.RETURN_REASON ||
        '',
      RETURN_USER_ID:
        reportData.returnUserId ||
        reportData.ReturnUserId ||
        reportData.RETURN_USER_ID ||
        '',

      PM_CD: reportData.pmCd || reportData.PmCd || reportData.PM_CD || '',
      CUST_CD: reportData.custCd || reportData.CustCd || reportData.CUST_CD || '',
      DEP_CD: reportData.depCd || reportData.DepCd || reportData.DEP_CD || '',
      USER_ID: reportData.userId || reportData.UserId || reportData.USER_ID || '',
    };

    // 테이블 데이터 구성
    const printData = {
      FileName: 'PER_CUSTOM',
      HeaderData: JSON.stringify(headerData),
      TableDataMain,
      TableData1: JSON.stringify(riskTableDataHorizontal),
      TableData2: JSON.stringify(equipmentTableDataHorizontal),
      TableData3: JSON.stringify(preparationTableData),
      TableData4: JSON.stringify([]),
      TableData5: JSON.stringify([]),
      TableData6: JSON.stringify([]),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 데이터 생성에 실패했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
